import { useParams, Link } from "react-router-dom";
import { PublicNav, Footer } from "../components/PublicLayout";

const CONTENT = {
  privacy: {
    title: "Privacy policy",
    body: [
      ["What we collect", "We collect your name, email address and password (stored only as a secure hash), your question-attempt history, flags and reports, and subscription status. Payment card details are processed by Stripe and never touch our servers."],
      ["How we use it", "Your data is used to provide the question-bank service: authentication, progress tracking, subscription management and content quality improvement. We do not sell your data."],
      ["Clinical data", "PAMind does not collect patient-identifiable information. Please never enter real patient details into question reports or feedback."],
      ["Retention & deletion", "Your question history is kept permanently so your progress survives subscription gaps. You can delete your account and all associated data at any time from Account settings."],
      ["Your rights", "Under UK GDPR you may request access, correction, export or deletion of your personal data by contacting us."],
    ],
  },
  terms: {
    title: "Terms & conditions",
    body: [
      ["The service", "PAMind provides an online question bank for UK Physician Associate students and qualified PAs. Content is educational and does not constitute medical advice, nor a substitute for current national guidance or clinical judgement."],
      ["Subscriptions", "The monthly plan renews automatically until cancelled; you can cancel anytime and keep access until the end of the paid period. The 3, 6 and 12-month plans are prepaid access periods and do not auto-renew. Payments are processed by Stripe."],
      ["Refunds", "If you believe you have been charged in error, contact us within 14 days and we will review your case fairly."],
      ["Acceptable use", "Accounts are personal. Question content is original PAMind material and must not be copied, scraped, redistributed or resold."],
      ["Accuracy", "Questions are clinically reviewed before publication and carry references and review dates, but medicine changes. If you spot an issue, use the in-app report tool."],
      ["Independence", "PAMind is an independent educational resource and is not affiliated with or endorsed by the Faculty of Physician Associates, Royal College of Physicians, General Medical Council or any UK university."],
    ],
  },
  cookies: {
    title: "Cookie policy",
    body: [
      ["What we use", "We use strictly necessary cookies only: secure authentication cookies that keep you logged in. We do not use advertising or third-party tracking cookies."],
      ["Managing cookies", "You can block cookies in your browser settings, but the service will not function without the authentication cookies."],
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const content = CONTENT[page] || CONTENT.privacy;
  return (
    <div className="min-h-screen bg-background" data-testid="legal-page">
      <PublicNav />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="flex gap-4 mb-10 text-sm font-medium">
          {Object.keys(CONTENT).map((k) => (
            <Link key={k} to={`/legal/${k}`} data-testid={`legal-tab-${k}`}
              className={`px-4 py-2 rounded-md border transition-colors ${page === k ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/50"}`}>
              {CONTENT[k].title}
            </Link>
          ))}
        </div>
        <h1 className="font-serif text-3xl md:text-4xl font-bold tracking-tight mb-8" data-testid="legal-title">{content.title}</h1>
        <div className="space-y-8">
          {content.body.map(([h, b]) => (
            <section key={h}>
              <h2 className="font-display font-semibold text-lg mb-2">{h}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">{b}</p>
            </section>
          ))}
        </div>
        <p className="mt-10 text-xs text-muted-foreground">Last updated: June 2026.</p>
      </div>
      <Footer />
    </div>
  );
}
